import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import bug_svg from '../../../assets/img/SVG_icons/Left/main_control/bug.svg';
import { img } from '@phi/components';
import { showxml } from '@frontend/debug';
import BugTooltip from './BugTooltip';

export const BugIcon = bug_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Report a bug';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                showxml();
        },
    },

    render() {
        return h(BarButton, {
            id: 'bug-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 14,
            active: false,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(bug_svg, this.alt),
            tooltip: BugTooltip,
        });
    },
});
